<div class="mb-3">
  <div>
    <form>
      <kendo-grid
        #grid
        [data]="permissions"
        [sortable]="true"
        [reorderable]="true"
        [resizable]="true"
        (cellClick)="cellClickHandler($event)"
        (cellClose)="cellCloseHandler($event)"
      >
        <ng-template kendoGridToolbarTemplate>
          <button
            kendoButton
            class="btn btn-secondary m-2"
            type="button"
            (click)="cancelChanges(grid)"
            i18n
          >
            Änderungen verwerfen
          </button>
        </ng-template>
        <ng-template kendoGridNoRecordsTemplate>
          <app-grid-no-records [loading]="loading" loadingText="Berechtigungen werden geladen…" i18n-loadingText></app-grid-no-records>
        </ng-template>
        <ng-template kendoGridToolbarTemplate>
          <button kendoGridPDFCommand icon="file-pdf" i18n>PDF-Export</button>
        </ng-template>

        <kendo-grid-column field="description" i18n-title title="Berechtigung" [width]="500">
        </kendo-grid-column>

        <kendo-grid-column field="value" editor="boolean" i18n-title title="Erlaubt" [width]="120">
          <ng-template kendoGridCellTemplate let-dataItem>
            <input type="checkbox" [checked]="dataItem.value" disabled />
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-pdf
          fileName="Kundenberechtigungen.pdf"
          [allPages]="true"
          paperSize="A4"
          [repeatHeaders]="true"
          [scale]="0.7"
        >
          <kendo-grid-column field="description" i18n-title title="Beschreibung" [width]="250">
          </kendo-grid-column>

          <kendo-grid-checkbox-column
            field="isActive"
            i18n-title
            title="Erlaubt"
            [width]="120"
          ></kendo-grid-checkbox-column>
        </kendo-grid-pdf>
      </kendo-grid>

      <div class="mt-5">
        <button class="btn btn-secondary m-2" type="button" (click)="onBackClicked()" i18n>
          Zurück
        </button>
        <button
          kendoButton
          class="btn btn-secondary m-2"
          type="button"
          [asyncClick]="saveChanges(grid)"
          [disabled]="saveBtn.disabled"
          #saveBtn="asyncClick"
          i18n
        >
          @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Bestätigen
        </button>
      </div>
    </form>
  </div>
</div>
